import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSpecies from './species.reducer';

export const selectSpeciesState = createFeatureSelector<fromSpecies.SpeciesState>(fromSpecies.speciesesFeatureKey);

export const selectAllSpecies = createSelector(
  selectSpeciesState,
  fromSpecies.selectAll
);
